@use '../../styling/colors.scss' as *;

.Main {
  height: 100%;
  box-sizing: border-box;
  flex: 1; // it should consume the available space in a flexbox
  overflow: hidden;

  > div {
    border-radius: 8px;
    border: solid 1px $theme-color-borders;
    background: $theme-color-background;
    padding: 32px 20px 60px;
    height: 100%;
    box-sizing: border-box;
  }
}
